import { render, staticRenderFns } from "./BlujayBcaUserLocationIndex.vue?vue&type=template&id=16611370&scoped=true&"
import script from "./BlujayBcaUserLocationIndex.vue?vue&type=script&lang=js&"
export * from "./BlujayBcaUserLocationIndex.vue?vue&type=script&lang=js&"
import style0 from "./BlujayBcaUserLocationIndex.vue?vue&type=style&index=0&id=16611370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16611370",
  null
  
)

export default component.exports